import common from './common';

const validate = {
  isEmptyString: (str?: string | null) => {
    return !str || str.trim() == '';
  },
  string: (data?: string, defaultVal: string = '') => {
    const isEmpty = validate.isEmptyString(data);
    return isEmpty ? defaultVal : data!;
  },

  number: (data?: any, max?: number, min?: number, defaultVal: number = 0) => {
    const _n = Number(data);
    if (!Number.isNaN(_n)) {
      let n = _n;
      if (max != undefined) {
        n = n < max ? n : max;
      }
      if (min != undefined) {
        n = n > min ? n : min;
      }
      return n;
    }
    return defaultVal;
  },

  numberString: (data?: any, max?: number, min?: number, defaultVal: number = 0) => {
    return validate.number(data, max, min, defaultVal).toString();
  },

  timeString: (data?: any, limit: number = 59): string => {
    const _n = Number(data);
    if (!Number.isNaN(_n)) {
      const n = _n < 0 ? 0 : _n > limit ? limit : _n;
      return common.str.padding(n, 2, '0', 'left');
    }
    return '00';
  },

  errorImg: (e: React.SyntheticEvent<HTMLImageElement, Event>, imgPath: string) => {
    e.currentTarget.src = require('@assets/images/' + imgPath);
  },
};

export default validate;
